import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import { SourceChangeReviewPage } from "@/screens/Products/components/SourceChanges/SourceChangeReviewPage"

export const Route: AnyRoute = createFileRoute("/app/product/$productId/source/$sourceId/")({
  component: () => <SourceChangeReviewPage />,
})
